module.exports = __webpack_public_path__ + "static/media/forphototools.b0bfc961.png";